import {
  FormFooter as BaseFormFooter,
  FormFooterSubmit,
  FormFooterCancel,
} from 'components/FormFooter';
import { useFormPrompt } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';

interface Props {
  submitLoading?: boolean;
}

export const FormFooter = ({ submitLoading }: Props) => {
  const { readOnly, dirty, setReadOnly } = useFormContext();

  const { confirmIsChanged } = useFormPrompt();

  const disableEditable = () => {
    confirmIsChanged(() => setReadOnly(true));
  };

  return (
    <BaseFormFooter visible={!readOnly}>
      <FormFooterCancel onClick={disableEditable} />
      <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
    </BaseFormFooter>
  );
};
